import React from 'react'
import {Flex} from '/app/src/component'
import style from './style.css'

class SearchInput extends React.Component
{
    constructor(props){
        super(props);
        this.state = {
            searchInput: '',
        }
        this._searchInputHandler = this._searchInputHandler.bind(this)
    }

    _searchInputHandler(event){
        event.target.name = this.props.name
        this.setState({searchInput: event.target.value})
        this.props.onChange(event)
    }

    render()
    {

        let placeholder = this.props.placeholder || 'Sök'
        return(
                <Flex width='100%' className={style.Search} basis='63px'>
                    <Flex grow>
                        <input
                            onChange={this._searchInputHandler}
                            value={this.state.searchInput}
                            placeholder={placeholder}
                            className={style.SearchInput}/>
                    </Flex>
                </Flex>
        );
    }

}

export default SearchInput



// WEBPACK FOOTER //
// ./src/component/Forms/SearchInput/index.js